<template>
  <div>
    <b-modal id="matterLegalNoticeFormModal" ref="matterLegalNoticeFormModal" centered size="lg" no-close-on-backdrop :title="$t('matter.law_matter_legal_notice')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate()">
      <b-row>
        <b-col class="col-lg-12">
          <b-form>
            <label for="matter-legal-notice-counter-party-input">{{ $t('matterLegalNotice.counter_party') }}</label>
            <b-form-group>
              <b-form-select id="matter-legal-notice-counter-party-input" size="sm" v-model="lawCounterPartySelect" value-field="id" text-field="name" :options="lawCounterPartyOptions" />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-12">
          <b-form>
            <label for="matter-legal-notice-counter-party-attorney-input">{{ $t('matterLegalNotice.counter_party_attorney') }}</label>
            <b-form-group>
              <b-form-select id="matter-legal-notice-counter-party-attorney-input" size="sm" v-model="lawCounterPartyAttorneySelect" value-field="id" text-field="name" :options="lawCounterPartyAttorneyOptions" />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-4">
          <b-form>
            <label for="matter-legal-notice-sent-date-input">{{ $t('matterLegalNotice.sent_date') }}</label>
            <b-form-group>
              <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="sentDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col class="col-lg-4">
          <b-form>
            <label for="matter-legal-notice-served-date-input">{{ $t('matterLegalNotice.served_date') }}</label>
            <b-form-group>
              <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="servedDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col class="col-lg-4">
          <b-form>
            <label for="matter-legal-notice-received-date-input">{{ $t('matterLegalNotice.received_date') }}</label>
            <b-form-group>
              <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="receivedDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-4">
          <b-form>
            <label for="matter-legal-notice-resent-date-input">{{ $t('matterLegalNotice.resent_date') }}</label>
            <b-form-group>
              <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="reSentDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col class="col-lg-4">
          <b-form>
            <label for="matter-legal-notice-reserved-date-input">{{ $t('matterLegalNotice.served_date') }}</label>
            <b-form-group>
              <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="reServedDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col class="col-lg-4">
          <b-form>
            <label for="matter-legal-notice-rereceived-date-input">{{ $t('matterLegalNotice.received_date') }}</label>
            <b-form-group>
              <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="reReceivedDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-6">
          <b-form>
            <label for="matter-legal-notice-outcome-input">{{ $t('matterLegalNotice.outcome') }}</label>
            <b-form-group>
              <b-form-select id="matter-legal-notice-outcome-input" size="sm" v-model="lawMatterOutcomeSelect" value-field="id" text-field="name" :options="lawMatterOutcomeOptions" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col class="col-lg-6">
              <b-form>
                <label>{{ $t('matter.process_result') }}</label>
                <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
              </b-form>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawCounterPartySelect: 0,
            lawCounterPartyOptions: [] ,
            lawCounterPartyAttorneySelect:0,
            lawCounterPartyAttorneyOptions: [],
            lawMatterOutcomeSelect:0,
            lawMatterOutcomeOptions: [],
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
            sentDate: null,
            servedDate: null,
            receivedDate: null,
            reSentDate: null,
            reServedDate: null,
            reReceivedDate:null
        }
    },
    methods: {
        async showLegalNotice(id, lawMatterId) {
            this.$refs['matterLegalNoticeFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId

            const data = {id: this.id}
            const controller = {name: 'LawMatterLegalNotice'}
            const payload = {data: data,controller: controller}

            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {

                    this.lawCounterPartyOptions = response.data.lawCounterPartyList
                    if (this.lawCounterPartyOptions != null) {
                        this.lawCounterPartyOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawCounterPartyAttorneyOptions = response.data.lawCounterPartyAttorneyList
                    if (this.lawCounterPartyAttorneyOptions != null) {
                        this.lawCounterPartyAttorneyOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawMatterOutcomeOptions = response.data.lawMatterOutcomeList
                    if (this.lawMatterOutcomeOptions != null) {
                        this.lawMatterOutcomeOptions.splice(0, 0, this.$nullSelected())
                    }

                    this.lawCounterPartySelect = response.data.lawMatterLegalNotice.lawCounterPartyId
                    this.lawCounterPartyAttorneySelect =  response.data.lawMatterLegalNotice.lawCounterPartyAttorneyId
                    this.lawMatterOutcomeSelect = response.data.lawMatterLegalNotice.lawMatterOutcomeId

                     this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                     this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                     this.lawMatterProcessResultSelect = response.data.lawMatterLegalNotice.lawMatterProcessResultId

                    this.sentDate = response.data.lawMatterLegalNotice.sentDate
                    this.servedDate = response.data.lawMatterLegalNotice.servedDate
                    this.receivedDate = response.data.lawMatterLegalNotice.receivedDate
                    this.reSentDate = response.data.lawMatterLegalNotice.reSentDate
                    this.reServedDate = response.data.lawMatterLegalNotice.reServedDate
                    this.reReceivedDate = response.data.lawMatterLegalNotice.reReceivedDate

                } else {
                    this.$bvModal.hide('matterLegalNoticeFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
               
        },
        async addOrUpdate() {
            const  lawMatterLegalNoticeData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            lawCounterPartyId: this.lawCounterPartySelect,
                            lawCounterPartyAttorneyId: this.lawCounterPartyAttorneySelect,
                            lawMatterOutcomeId: this.lawMatterOutcomeSelect,
                            sentDate: this.sentDate,
                            servedDate: this.servedDate,
                            receivedDate: this.receivedDate,
                            reSentDate: this.reSentDate,
                            reServedDate: this.reServedDate,
                            reReceivedDate: this.reReceivedDate,
                            lawMatterProcessResultId :this.lawMatterProcessResultSelect
                        }
            const controller = {name: 'LawMatterLegalNotice' }
            const payload = {data: lawMatterLegalNoticeData,controller: controller}
                
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(8, this.id, this.lawMatterId,this.employeeId) 
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterLegalNoticeFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
